import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { ReportLocationBaseService } from './report-location-base.service';

@Injectable()
export class ReportLocationService extends ReportLocationBaseService {
  constructor() {
    const http = inject(HttpClient);

    super(http);
  }
}
